import { Node, Fragment } from '@atlaskit/editor-prosemirror/model';
import { Transform } from '@atlaskit/editor-prosemirror/transform';

import { type DiffFragment } from './createDiffFromFragments';

interface DiffOperationParams {
	transform: Transform;
	from: number;
	to: number;
	replacement?: Fragment;
}
interface DiffActions {
	onAddition: (params: DiffOperationParams) => void;
	onDeletion: (params: DiffOperationParams) => void;
	onReplacement: (params: DiffOperationParams) => void;
}

export const createDiffTransformation = (
	docFrom: Node,
	diffObjects: DiffFragment[],
	actions: DiffActions,
): Transform => {
	const transform = new Transform(docFrom);
	const { onAddition, onDeletion, onReplacement } = actions;

	diffObjects.forEach((diff) => {
		const mappedTo = transform.mapping.map(diff.to);
		const mappedFrom = Math.min(
			transform.mapping.map(diff.from),
			transform.doc.content.size,
			mappedTo,
		);

		const params = {
			...diff,
			transform,
			from: mappedFrom,
			to: mappedTo,
		};

		switch (diff.type) {
			case 'ADDITION':
				onAddition(params);
				break;
			case 'DELETION':
				onDeletion(params);
				break;
			case 'REPLACEMENT':
				onReplacement(params);
				break;
		}
	});

	return transform;
};
